<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <Modal
      :id="modalId"
      :options="options"
      :title="`Want to send ${target.profile.nickname} an icebreaker?`"
    >
      <div class="tw-m-4 tw-mb-8">
        They'll be notified of your request, once they accept you'll be able to start chatting!

        <div class="tw-pl-4 tw-my-4">
          <textarea
            v-model="form.icebreaker"
            placeholder="Write something sweet"
            rows="4"
            class="tw-form-textarea tw-w-full"
            :class="{'has-error': form.errors.has('icebreaker')}"
          />

          <span
            v-show="form.errors.has('icebreaker')"
            class="help-block"
          >
            {{ form.errors.first('icebreaker') }}
          </span>
        </div>
      </div>

      <div class="tw-flex tw-justify-end">
        <button
          type="button"
          class="btn btn-lg btn-gradient"
          :data-cy="`cancel-button`"
          @click.prevent="hideModal"
        >
          Nevermind
        </button>
        <button
          type="button"
          class="tw-ml-2 btn btn-lg btn-gradient"
          :data-cy="`ok-button`"
          @click.prevent="sendIcebreaker"
        >
          Send Icebreaker
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Form from 'form-backend-validation';

import actionHelpers from '@/mixins/helpers/action-helpers';
import modalHelpers from '@/mixins/helpers/modal-helpers';

export default {
  mixins: [
    actionHelpers, //
    modalHelpers, //
  ],

  data() {
    return {
      options: {
        size: 'md',
      },

      form: new Form(
        {
          userId: 0,
          icebreaker: null,
        },
        {
          resetOnSuccess: true,
        },
      ),
    };
  },

  computed: {
    modalId() {
      return 'icebreaker:send';
    },
  },

  methods: {
    sendIcebreaker() {
      this.form.userId = this.target.id;

      return this.form
        .post('/api/icebreakers', this.form)
        .then(() => {
          this.$store.set('general/loading', false);
          this.$root.$emit('bv::hide::modal', this.modalId);

          this.$swal('Icebreaker Sent!', "They'll be notified and once they've replied you'll be notified back", 'success');

          Bus.$emit('refresh');
        })
        .catch((response) => {
          console.log(response);
        });
    },
  },
};
</script>
